import { useAuthActions } from '@core-frontend/core-frontend';
import type { Tokens } from '@core-frontend/core-frontend';

import { getUserInfoAndUpdateStore } from '@/pages/auth/model';

import type { LoginRequest } from '@/widgets/auth/Login/models';

import { persistTokens } from '@/entities/session';

import { setSubdomainName } from '@/shared/lib/domain';
import { env } from '@/shared/lib/env';
import { useMutate } from '@/shared/model/hooks';

import { loginAsync } from '../api';

export const useLoginMutation = () => {
  const { setTokens } = useAuthActions();

  return useMutate<Tokens, { data: LoginRequest; inCore?: boolean }>(
    ({ data, inCore }) => loginAsync(data, inCore),
    {
      onSuccess: (data, { inCore }) => {
        persistTokens(data.access_token, data.refresh_token);
        setTokens(data.access_token, data.refresh_token);
        getUserInfoAndUpdateStore();
        setSubdomainName(env.VITE_APP_TENANT, !!inCore);
      },
    }
  );
};
